import { IconButton as MUIIconButton, SxProps, Theme } from '@mui/material';
import { IconType } from '@/assets/icons';
import Icon from '@/components/ui/Icon';
import { FC } from 'react';

import { SXStyleSheet } from '@/utils';
import style from './style';

export interface IconButtonProps {
  icon: IconType;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  disabled?: boolean;
  size?: number;
  variant?: 'icon' | 'outlined' | 'light' | 'primary';
  /**
   * Zugaenglicher Name. Ein Icon-only-Button hat sonst KEINEN — Screenreader
   * lesen im Zweifel den SVG-Dateinamen vor, und im Test ist er nur ueber
   * Positionsraten greifbar. Optional, damit die bestehenden Aufrufer
   * unveraendert bleiben.
   */
  ariaLabel?: string;
}

const IconButton: FC<IconButtonProps> = ({
  icon,
  onClick,
  sx,
  disabled,
  iconSx,
  size,
  variant = 'icon',
  ariaLabel,
}) => {
  return (
    <MUIIconButton
      sx={SXStyleSheet.merge(sx, style[variant])}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <Icon
        sx={SXStyleSheet.merge(iconSx, { width: size, height: size })}
        icon={icon}
      />
    </MUIIconButton>
  );
};

export default IconButton;
